import commonGAttributes from "./commonGAttributes";
const strokeWidth = "stroke-width";
const strokeLinecap = "stroke-linecap";

const partOne = {
  "icon-phone-fill": {
    g: [
      { stroke: "currentColor" },
      { fill: "currentColor" },
      { [strokeWidth]: "1" },
      { fill: "none" },
      { "fill-rule": "evenodd" }
    ],
    parts: [`<rect x="4.5" y="0.5" width="11" height="19" rx="2"></rect>`],
    viewBox: "0 0 20 20"
  },
  "icon-add": {
    g: [
      { transform: "translate(2.000000, 0.000000)" },
      { stroke: "currentColor" }
    ],
    parts: [
      `<path d="M7,0 L7,14" id="Shape"></path>`,
      `<path d="M0,7 L14,7" id="Shape"></path>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-arrow-up": {
    g: commonGAttributes.commonFour,
    parts: [
      `<polyline stroke="currentColor" stroke-linejoin="round" points="4 10 10 4 16 10"></polyline>`,
      `<path d="M10,5 L10,17" id="Line-3" stroke="currentColor"></path>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-arrow-down": {
    g: commonGAttributes.commonFour,
    parts: [
      `<polyline stroke="currentColor" stroke-linejoin="round" transform="translate(10.000000, 13.000000)
           rotate(180.000000) translate(-10.000000, -13.000000) " points="4 16 10 10 16 16"></polyline>`,
      `<path d="M10,4 L10,16" id="Line-3" stroke="currentColor"></path>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-arrow-up-double": {
    g: commonGAttributes.commonFour,
    parts: [
      `<polyline stroke="currentColor" stroke-linejoin="round" points="4 9 10 3 16 9"></polyline>`,
      `<polyline stroke="currentColor" stroke-linejoin="round" points="4 14 10 8 16 14"></polyline>`,
      `<path d="M10,8 L10,19" id="Line-3" stroke="currentColor"></path>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-arrow-down-double": {
    g: commonGAttributes.commonFour,
    parts: [
      `<polyline stroke="currentColor" stroke-linejoin="round" transform="translate(10.000000, 15.000000)
          rotate(180.000000) translate(-10.000000, -15.000000) " points="4 18 10 12 16 18"></polyline>`,
      `<polyline stroke="currentColor" stroke-linejoin="round" transform="translate(10.000000, 10.000000)
          rotate(180.000000) translate(-10.000000, -10.000000) " points="4 13 10 7 16 13"></polyline>`,
      `<path d="M10,1 L10,12" id="Line-3" stroke="currentColor"></path>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-arrow-up-with-shadow": {
    g: [],
    parts: [
      `<g style="transform: scale(.8)">
              <polygon id="path-1" points="168.5 788 179 799 158 799"></polygon>
              <filter x="-9.5%" y="-37.3%" width="119.0%" height="136.4%" filterUnits="objectBoundingBox" id="filter-2">
                  <feOffset dx="0" dy="-1" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
                  <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
                  <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.35 0" type="matrix" in="shadowBlurOuter1"></feColorMatrix>
              </filter>
              <g style="transform: translateY(2px)" stroke-width="1"  fill-rule="evenodd">
                  <g transform="translate(-157.000000, -786.000000)" id="Triangle">
                      <g>
                          <use  fill-opacity="1" filter="url(#filter-2)" xlink:href="#path-1"></use>
                          <use id="top-arrow-fill" fill="currentColor" fill-rule="evenodd" xlink:href="#path-1"></use>
                      </g>
                  </g>
              </g>
          </g>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-bag": {
    g: [
      { fill: "none" },
      { transform: "translate(2.000000, 0.000000)" },
      { stroke: "currentColor" }
    ],
    parts: [
      `<path d="M0,18.0355649 C0.0307996364,18.8315623 0.684671156,19.4699306 1.5,19.5 L14.6,19.5 C15.3760924,19.4223016 15.9740637,
          18.7968086 16,18.0355649 L15.27,5.5 L0.73,5.5 L0,18.0355649 Z" id="Shape"></path>`,
      `<path d="M12,11 L12,4.5 C12,2.290861 10.209139,0.5 8,0.5 C5.790861,0.5 4,2.290861 4,4.5 L4,11" id="Shape"></path>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-largecart-empty": {
    g: commonGAttributes.commonThree,
    parts: [
      `<g id="Group" stroke="currentColor" transform="translate(0.000000, 0.500000)">
            <circle id="Oval" cx="11" cy="21.5" r="1.5"></circle>
            <circle id="Oval" cx="23" cy="21.5" r="1.5"></circle>
            <polyline id="Shape" stroke-linecap="round" points="0 -5.24580379e-15 3.5 -5.41233725e-15 9.5 18 23.5 18"></polyline>
            <path d="M8.05714286,14 L21.6400424,14 C22.9848342,14 24.1653247,13.1050925 24.5285445,11.8102811 L27,3 L4.5,3" id="Shape"></path>
        </g>`
    ],
    viewBox: "0 0 30 30"
  },
  "icon-largecart-099": {
    g: commonGAttributes.commonThree,
    parts: [
      `<g id="Group" transform="translate(0.000000, 0.500000)" stroke="currentColor">
            <circle id="Oval" cx="11" cy="21.5" r="1.5"></circle>
            <circle id="Oval" cx="23" cy="21.5" r="1.5"></circle>
            <polyline id="Shape" stroke-linecap="round" points="0 -5.24580379e-15 3.5 -5.41233725e-15 9.5 18 23.5 18"></polyline>
            <path d="M8.5,14 L21.6400424,14 C22.9848342,14 24.1653247,13.1050925 24.5285445,11.8102811 L27,3" id="Shape" stroke-linecap="round"></path>
        </g>`
    ],
    viewBox: "0 0 30 30"
  },
  "icon-largecart-99p": {
    g: commonGAttributes.commonThree,
    parts: [
      `<g id="Group" transform="translate(0.000000, 0.500000)" stroke="currentColor">
            <circle id="Oval" cx="11" cy="21.5" r="1.5"></circle>
            <circle id="Oval" cx="23" cy="21.5" r="1.5"></circle>
            <polyline id="Shape" stroke-linecap="round" points="0 -5.24580379e-15 3.5 -5.41233725e-15 9.5 18 23.5 18"></polyline>
            <path d="M8.5,14 L21.6400424,14 C22.9848342,14 24.1653247,13.1050925 24.5285445,11.8102811 L25.6758319,7.72041412" id="Shape" stroke-linecap="round"></path>
        </g>
        <g id="Group1"  transform="translate(0.500000, -3.500000)" stroke="currentColor">
            <path d="M27,9.5 L27,4.5" id="Shape" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M24.5,7 L29.5,6.99990176" id="Shape" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
        </g>`
    ],
    viewBox: "0 0 30 30"
  },
  "icon-smallcart-empty": {
    g: commonGAttributes.commonTwo,
    parts: [
      `<g id="Asset-9Cart" transform="translate(0.000000, 0.000000)" stroke="currentColor">
              <circle id="Oval" cx="7" cy="14.5" r="1"></circle>
              <circle id="Oval" cx="15" cy="14.5" r="1"></circle>
              <polyline id="Shape" stroke-linecap="round" points="5.68434189e-14 0 3 0 6 12 16 12"></polyline>
              <path d="M5.5,9 L14.7370958,9 C16.0765368,9 17.2536948,8.11206806 17.6216676,6.82416338 L19,2 L3.5,2" id="Shape"></path>
          </g>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-smallcart-add": {
    g: commonGAttributes.commonTwo,
    parts: [
      `<g id="-icon💎/cart/Small/SmallcartLG-black" stroke="currentColor">
              <g id="Asset-9Cart" transform="translate(0.000000, 4.000000)">
                  <circle id="Oval" cx="7" cy="14.5" r="1"></circle>
                  <circle id="Oval" cx="15" cy="14.5" r="1"></circle>
                  <polyline id="Shape" stroke-linecap="round" points="5.68434189e-14 0 3 0 6 12 16 12"></polyline>
                  <path d="M5.5,9 L14.7370958,9 C16.0765368,9 17.2536948,8.11206806 17.6216676,6.82416338 L19,2 L3.5,2" id="Shape"></path>
              </g>
          </g>
          <g id="Group" transform="translate(12.000000, 0.000000)">
              <circle id="Oval" fill="currentColor" cx="5" cy="5" r="5"></circle>
              <path d="M5,7.5 L5,2.5" id="Shape" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round"></path>
              <path d="M2.5,5 L7.5,4.99990176" id="Shape" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round"></path>
          </g>`
    ],
    viewBox: "0 0 22 22"
  },
  "icon-refund": {
    g: [
      { fill: "none" },
      { [strokeWidth]: "1" },
      { stroke: "none" },
      { "fill-rule": "evenodd" },
      { transform: "translate(-730.000000, -775.000000)" }
    ],
    parts: [
      `<g id="Group-7" transform="translate(728.000000, 738.000000)">
              <g id="Refund-icon" transform="translate(0.000000, 35.000000)">
                  <g id="Group-4">
                      <g id="�-icon/refreshADR/small/RefreshSM-black" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
                          <g id="Icon-small-ADRrenew" transform="translate(2.400000, 2.400000)">
                              <path d="M3.444,15.744 C6.22686297,18.5225127 10.5275882,19.0887969 13.9348339,17.125347 C17.3420797,
                              15.1618971 19.0085975,11.156946 18,7.356" id="Shape"/>
                              <path d="M15.756,3.456 C12.9720711,0.672485415 8.66589268,0.105287861 5.25614717,2.07298931 C1.84640166,
                              4.04069076 0.182902771,8.05287935 1.2,11.856" id="Shape"/>
                              <polyline id="Shape" points="6.804 14.808 3.444 15.744 3.024 19.2"/>
                              <polyline id="Shape" points="16.176 0 15.756 3.456 12.396 4.392"/>
                          </g>
                      </g>
                      <path d="M11.519,16.35 L11.519,15.371 C10.397,15.305 9.55,14.843 9,14.216 L9.539,13.523 C9.968,14.007 10.639,14.458 11.519,
                      14.557 L11.519,11.873 C10.397,11.565 9.231,11.191 9.231,9.838 C9.231,8.694 10.188,7.891 11.519,7.814 L11.519,6.802 L12.19,
                      6.802 L12.19,7.825 C13.103,7.913 13.818,8.265 14.357,8.826 L13.807,9.497 C13.367,9.024 12.806,8.749 12.19,8.661 L12.19,11.048 C13.323,
                      11.367 14.522,11.796 14.522,13.226 C14.522,14.227 13.884,15.239 12.19,15.371 L12.19,16.35 L11.519,16.35 Z M13.576,13.303 C13.576,
                      12.588 12.96,12.291 12.19,12.06 L12.19,14.557 C13.235,14.447 13.576,13.82 13.576,13.303 Z M10.177,9.783 C10.177,10.399 10.771,
                      10.652 11.519,10.872 L11.519,8.628 C10.727,8.683 10.177,9.134 10.177,9.783 Z" id="$" fill="currentColor" fill-rule="nonzero"/>
                  </g>
              </g>
          </g>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-addtocart": {
    g: [
      { fill: "none" },
      { [strokeWidth]: "1" },
      { stroke: "currentColor" },
      { transform: "translate(-53.000000, -15.000000)" }
    ],
    parts: [
      `<g id="Group">
            <g id="-icon�/cart/Small/SmallcartLG-white" transform="translate(49.000000, 8.000000)">
                <g id="Asset-9Cart" transform="translate(4.000000, 8.000000)">
                    <circle id="Oval" cx="7" cy="14.5" r="1"/>
                    <circle id="Oval" cx="15" cy="14.5" r="1"/>
                    <polyline id="Shape" stroke-linecap="round" points="5.68434189e-14 0 3 0 6 12 16 12"/>
                    <path d="M5.5,9 L14.7370958,9 C16.0765368,9 17.2536948,8.11206806 17.6216676,6.82416338 L19,2 L3.5,2" id="Shape"/>
                </g>
            </g>
        </g>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-cart-trans-plus": {
    g: commonGAttributes.commonTwo,
    parts: [
      `<g id="-icon💎/cart/Add/large/cartAddLG-white" transform="translate(2.000000, 3.000000)">
              <g id="Asset-9Cart" transform="translate(0.000000, 4.000000)" stroke="currentColor">
                  <circle id="Oval" cx="7" cy="14.5" r="1"></circle>
                  <circle id="Oval" cx="15" cy="14.5" r="1"></circle>
                  <polyline id="Shape" stroke-linecap="round" points="5.68434189e-14 0 3 0 6 12 16 12"></polyline>
                  <path d="M5.5,9 L14.7370958,9 C16.0765368,9 17.2536948,8.11206806 17.6216676,6.82416338 L18.1438633,4.99647853 L15,4.5 L13.5,2 L3.5,2" id="Shape"></path>
              </g>
              <g id="Group" transform="translate(12.000000, 0.000000)" fill="currentColor">
                  <path d="M5,10 C2.23857625,10 0,7.76142375 0,5 C0,2.23857625 2.23857625,0 5,0 C7.76142375,0 10,2.23857625 10,5 C10,7.76142375 7.76142375,10 5,
                  10 Z M4.5,5.4999607 L4.5,7.5 C4.5,7.77614237 4.72385763,8 5,8 C5.27614237,8 5.5,7.77614237 5.5,7.5 L5.5,5.49994105 L7.5,5.49990176 C7.7761522,
                  5.49990176 8,5.27603431 8,4.99990176 C8,4.72374956 7.77613255,4.49990176 7.5,4.49990176 L5.5,4.49994105 L5.5,2.5 C5.5,2.22385763 5.27614237,
                  2 5,2 C4.72385763,2 4.5,2.22385763 4.5,2.5 L4.5,4.4999607 L2.5,4.5 C2.2238478,4.50000543 2,4.72386745 2,5.00000982 C2,5.2761522 2.22386745,
                  5.5 2.5,5.5 L4.5,5.4999607 Z" id="Combined-Shape"></path>
              </g>
          </g>`
    ],
    viewBox: "0 0 25 25"
  },
  "icon-box": {
    g: [{ fill: "none" }, { stroke: "currentColor" }],
    parts: [
      `<polygon points="0.5 14.54 10.05 19.5 19.5 14.49 19.5 5.51 10.05 0.5 0.5 5.46"></polygon>
          <polyline points="6.66 8.76 10.05 10.58 19.5 5.51"></polyline>
          <polyline points="14.56 14.8 12.26 16.04 12.26 14.62"></polyline>
          <path d="M0.5,5.45 L4.8,7.76" id="Shape"></path>
          <path d="M10.05,19.5 L10.05,10.58" id="Shape"></path>
          <polyline points="4.8 10.02 4.8 7.75 14.36 2.78"></polyline>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-box-open": {
    g: [{ fill: "none" }, { stroke: "currentColor" }],
    parts: [
      `<polyline points="3.02 11.97 3.02 15.39 9.89 19.02 16.69 15.35 16.69 12.13"></polyline>
          <polyline points="16.69 7.73 9.89 4.06 3.02 7.69"></polyline>
          <path d="M9.89,19.02 L9.89,11.45" id="Shape"></path>
          <polyline points="9.89 11.45 12.29 14.48 19.5 10.62 16.69 7.73 9.89 11.45 3.02 7.69 0.77 4.56 7.67 0.98 9.89 4.06"></polyline>
          <polyline points="9.89 11.45 7.71 14.48 0.5 10.62 3.1 7.73 9.89 11.45"></polyline>
          <polyline points="9.89 11.45 3.02 7.69 0.77 4.56 7.67 0.98 9.89 4.06"></polyline>
          <polyline points="9.89 11.45 16.77 7.69 19.02 4.56 12.12 0.98 9.89 4.06"></polyline>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-broken-link": {
    g: [
      { fill: "none" },
      { "fill-rule": "evenodd" },
      { stroke: "currentColor" },
      { [strokeWidth]: "0.8568" },
      { [strokeLinecap]: "round" },
      { "stroke-miterlimit": "10" }
    ],
    parts: [
      `<line x1="13.3" y1="15.4" x2="14.1" y2="16.1"/>
          <line x1="6.7" y1="15.4" x2="5.9" y2="16.1"/>
          <line x1="10" y1="17.4" x2="10" y2="19.4"/>
          <line x1="6.7" y1="4.6" x2="5.9" y2="3.9"/>
          <line x1="13.3" y1="4.6" x2="14.1" y2="3.9"/>
          <line x1="10" y1="2.6" x2="10" y2="0.6"/>
          <path d="M12.6,7h2.5c1.6,0,3,1.3,3,3v0c0,1.6-1.3,3-3,3h-2.4"/>
          <path d="M7.3,13H4.9c-1.6,0-3-1.3-3-3v0c0-1.6,1.3-3,3-3h2.4"/>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-card": {
    g: [{ fill: "none" }, { transform: "translate(0.000000, 3.000000)" }],
    parts: [
      `<path d="M0.55,3.51 L19.45,3.51" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
          <path d="M0.55,5.6 L19.45,5.6" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
          <path d="M3.63,8.38 L13.91,8.38" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
          <path d="M17.69,1.08 C18.4096057,1.07997903 18.9945068,1.66041526 19,2.38 L19,11.62 C18.9945068,12.3395847 18.4096057,12.920021 17.69,12.92 L2.31,
          12.92 C1.5903943,12.920021 1.00549317,12.3395847 1,11.62 L1,2.38 C1.00549317,1.66041526 1.5903943,1.07997903 2.31,1.08 L17.69,1.08 Z M17.69,0.08 L2.31,
          0.08 C1.69827128,0.0773402848 1.11068499,0.31848635 0.677186086,0.750108634 C0.243687183,1.18173092 -5.78201702e-06,1.7682655 0,2.38 L0,11.62 C-5.78201702e-06,
          12.2317345 0.243687183,12.8182691 0.677186086,13.2498914 C1.11068499,13.6815137 1.69827128,13.9226597 2.31,13.92 L17.69,13.92 C18.3017287,13.9226597 18.889315,
          13.6815137 19.3228139,13.2498914 C19.7563128,12.8182691 20.0000058,12.2317345 20,11.62 L20,2.38 C20.0000058,1.7682655 19.7563128,1.18173092 19.3228139,
          0.750108634 C18.889315,0.31848635 18.3017287,0.0773402848 17.69,0.08 Z" fill="currentColor" fill-rule="nonzero"></path>
          <path d="M3.63,10.33 L6.51,10.33" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-cards": {
    g: commonGAttributes.commonTwo,
    parts: [
      `<g transform="translate(0.000000, 2.000000)" fill="currentColor" fill-rule="nonzero">
              <path d="M2.30553399,11.9606524 C1.93664695,11.9417895 1.5907185,11.7758324 1.34515188,11.4999148 C1.09958527,11.2239973 0.974879539,10.8611519 0.998938243,
              10.4925673 L1,2.46 C1,1.63157288 1.67157288,0.96 2.5,0.96 L15.54,0.96 C16.3684271,0.96 17.04,1.63157288 17.04,2.46 C17.04,2.73614237 17.2638576,2.96 17.54,
              2.96 C17.8161424,2.96 18.04,2.73614237 18.04,2.46 C18.04,1.07928813 16.9207119,-0.04 15.54,-0.04 L2.5,-0.04 C1.11928813,-0.04 -4.02455846e-16,
              1.07928813 -3.32199546e-16,2.46 L-3.32199546e-16,10.46 C-0.0404307917,11.0631076 0.174641406,11.6888844 0.598154843,12.1647422 C1.02166828,12.6406 1.61826953,
              12.9268159 2.25446601,12.9593476 C2.53024807,12.9734496 2.76524556,12.761316 2.77934759,12.485534 C2.79344962,12.2097519 2.58131605,11.9747544 2.30553399,
              11.9606524 Z" id="Shape"></path>
              <path d="M17.9,3.1 C18.1917381,3.1 18.4715274,3.21589252 18.6778175,3.42218254 C18.8841075,3.62847256 19,3.90826186 19,4.2 L19,12.6 C19,13.2075132 18.5075132,
              13.7 17.9,13.7 L3.9,13.7 C3.29248678,13.7 2.8,13.2075132 2.8,12.6 L2.8,4.2 C2.8,3.59248678 3.29248678,3.1 3.9,3.1 L17.9,3.1 L17.9,3.1 Z M17.9,2.1 L3.9,
              2.1 C2.74020203,2.1 1.8,3.04020203 1.8,4.2 L1.8,12.6 C1.8,13.759798 2.74020203,14.7 3.9,14.7 L17.9,14.7 C18.4569546,14.7 18.9910978,14.4787506 19.3849242,
              14.0849242 C19.7787506,13.6910978 20,13.1569546 20,12.6 L20,4.2 C20,3.64304537 19.7787506,3.10890215 19.3849242,2.71507576 C18.9910978,2.32124936 18.4569546,
              2.1 17.9,2.1 L17.9,2.1 Z" id="Shape"></path>
              <path d="M2.3,5.72 L19.49,5.72 C19.7661424,5.72 19.99,5.49614237 19.99,5.22 C19.99,4.94385763 19.7661424,4.72 19.49,4.72 L2.3,4.72 C2.02385763,4.72 1.8,
              4.94385763 1.8,5.22 C1.8,5.49614237 2.02385763,5.72 2.3,5.72 Z" id="Shape"></path>
              <path d="M2.3,7.67 L19.49,7.67 C19.7661424,7.67 19.99,7.44614237 19.99,7.17 C19.99,6.89385763 19.7661424,6.67 19.49,6.67 L2.3,6.67 C2.02385763,6.67 1.8,
              6.89385763 1.8,7.17 C1.8,7.44614237 2.02385763,7.67 2.3,7.67 Z" id="Shape"></path>
              <path d="M5.1,10.16 L14.46,10.16 C14.7361424,10.16 14.96,9.93614237 14.96,9.66 C14.96,9.38385763 14.7361424,9.16 14.46,9.16 L5.1,9.16 C4.82385763,9.16 4.6,
              9.38385763 4.6,9.66 C4.6,9.93614237 4.82385763,10.16 5.1,10.16 Z" id="Shape"></path>
              <path d="M5.1,11.98 L7.72,11.98 C7.99614237,11.98 8.22,11.7561424 8.22,11.48 C8.22,11.2038576 7.99614237,10.98 7.72,10.98 L5.1,10.98 C4.82385763,10.98 4.6,
              11.2038576 4.6,11.48 C4.6,11.7561424 4.82385763,11.98 5.1,11.98 Z" id="Shape"></path>
          </g>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-checkmark": {
    g: [
      { fill: "none" },
      { stroke: "currentColor" },
      { transform: "translate(2.000000, 5.000000)" }
    ],
    parts: [
      `<polyline points="0.43 4.85 5.57 10 15.57 0" stroke-width="1.5"></polyline>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-chevron-up": {
    g: commonGAttributes.commonOne,
    parts: [
      `<polyline stroke="currentColor" points="4 12 10 6 16 12"></polyline>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-chevron-down": {
    g: commonGAttributes.commonOne,
    parts: [
      `<polyline stroke="currentColor" transform="translate(10.000000, 11.000000) rotate(180.000000) translate(-10.000000, -11.000000) " points="4 14 10 8 16 14"></polyline>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-chevron-right": {
    g: commonGAttributes.commonOne,
    parts: [
      `<polyline stroke="currentColor" transform="translate(14.000000, 10.000000) rotate(90.000000) translate(-14.000000, -10.000000) " points="8 13 14 7 20 13"></polyline>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-chevron-left": {
    g: commonGAttributes.commonOne,
    parts: [
      `<polyline stroke="currentColor" transform="translate(6.000000, 10.000000) rotate(-90.000000) translate(-6.000000, -10.000000) " points="0 13 6 7 12 13"></polyline>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-close": {
    g: [
      { fill: "none" },
      { stroke: "currentColor" },
      { [strokeWidth]: "1.04" },
      { transform: "translate(4.000000, 4.000000)" }
    ],
    parts: [
      `<path d="M0,0 L12,12" id="Shape"></path>
           <path d="M0,12 L12,0" id="Shape"></path>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-info": {
    g: commonGAttributes.commonTwo,
    parts: [
      `<g id="Info1" transform="translate(2.000000, 2.000000)">
            <circle stroke="currentColor" cx="8" cy="8" r="8"></circle>
            <path d="M7.25117025,3.74735497 C7.24169603,3.54535836 7.31298677,3.34786764 7.44938989,3.1982439 C7.60122323,3.06522617 7.79799047,2.99458281 8,
            3.00056392 C8.20227601,2.99289149 8.39965242,3.06375354 8.55061011,3.1982439 C8.68701323,3.34786764 8.75830397,3.54535836 8.74882975,3.74735497 C8.76017652,
            3.94962831 8.68863296,4.14781935 8.55061011,4.29646603 C8.4005052,4.43294732 8.20303229,4.50581337 8,4.49963712 C7.79734285,4.50356256 7.60067904,
            4.43099506 7.44938989,4.29646603 C7.31136704,4.14781935 7.23982348,3.94962831 7.25117025,3.74735497 Z M8.75,13 L7.25,13 L7.25,6 L8.75,6 L8.75,13 Z"
            fill="currentColor" fill-rule="nonzero"></path>
          </g>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-info-filled": {
    g: commonGAttributes.commonTwo,
    parts: [
      `<g id="info2" transform="translate(0.593407, 0.593407)">
              <circle fill="currentColor" fill-rule="nonzero" cx="8.30769231" cy="8.30769231" r="8.30769231"></circle>
              <path d="M7.47692308,4.31406593 C7.46671246,4.09577472 7.54354432,3.88235289 7.69054945,3.72065934 C7.85418412,3.57691137 8.06624521,3.50056938 8.28395604,
              3.50703297 C8.50195407,3.49874162 8.71467168,3.57531995 8.87736264,3.72065934 C9.02436777,3.88235289 9.10119963,4.09577472 9.09098901,4.31406593 C9.10321771,
              4.53265621 9.0261134,4.74683486 8.87736264,4.90747253 C8.71559074,5.05496345 8.50276914,5.13370744 8.28395604,5.12703297 C8.06554725,5.13127507 7.85359763,
              5.05285371 7.69054945,4.90747253 C7.54179869,4.74683486 7.46469438,4.53265621 7.47692308,4.31406593 Z M9.04351648,13.1261538 L7.56593407,13.1261538 L7.56593407,
              6.15956044 L9.04351648,6.15956044 L9.04351648,13.1261538 Z" fill="#FFFFFF" fill-rule="nonzero"></path>
          </g>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-order-history": {
    g: commonGAttributes.commonTwo,
    parts: [
      `<g transform="translate(-0.540000, 0.500000)" fill="currentColor" fill-rule="nonzero">
              <path d="M6.04343848,6.65480082 C6.04343848,6.2654664 6.43665911,5.99924307 6.79814704,6.14383825 L11.3007941,7.94489707 C11.509729,8.02847104 11.6467326,
              8.23082982 11.6467326,8.45585964 L11.6467326,13.8590361 C11.6467326,14.2483705 11.253512,14.5145939 10.892024,14.3699987 L6.38937699,12.5689399 C6.18044205,
              12.4853659 6.04343848,12.2830071 6.04343848,12.0579773 L6.04343848,6.65480082 Z M7.14408554,7.46764681 L7.14408554,11.6853901 L10.5460855,13.0461901 L10.5460855,
              8.82844681 L7.14408554,7.46764681 Z" id="Path"></path>
              <path d="M15.3946711,6.14383825 C15.756159,5.99924307 16.1493797,6.2654664 16.1493797,6.65480082 L16.1493797,12.0579773 C16.1493797,12.2830071 16.0123761,
              12.4853659 15.8034412,12.5689399 L11.3007941,14.3699987 C10.9393062,14.5145939 10.5460855,14.2483705 10.5460855,13.8590361 L10.5460855,8.45585964 C10.5460855,
              8.23082982 10.6830891,8.02847104 10.892024,7.94489707 L15.3946711,6.14383825 Z M15.0487326,7.46764681 L11.6467326,8.82844681 L11.6467326,13.0461901 L15.0487326,
              11.6853901 L15.0487326,7.46764681 Z" id="Path"></path>
              <path d="M11.0964091,5.44645857 L15.3946711,7.16576338 C15.6768679,7.27864212 15.99714,7.14138268 16.1100187,6.85918584 C16.2228974,6.57698901 16.085638,
              6.25671698 15.8034412,6.14383825 L11.3007941,4.34277942 C11.1695909,4.29029814 11.0232272,4.29029814 10.892024,4.34277942 L6.38937699,6.14383825 C6.10718015,
              6.25671698 5.96992071,6.57698901 6.08279944,6.85918584 C6.19567818,7.14138268 6.51595021,7.27864212 6.79814704,7.16576338 L11.0964091,5.44645857 Z" id="Path"></path>
              <path d="M1.47062879,6.0007185 C1.16914491,6.03924289 0.955974115,6.31487405 0.994498502,6.61635794 C1.03302289,6.91784183 1.30865405,7.13101262 1.61013794,
              7.09248823 L4.28701988,6.75042937 C4.52570928,6.71992902 4.71690464,6.53789031 4.7590729,6.30098371 L5.23474018,3.62862522 C5.28800208,3.32939315 5.08860387,
              3.04364032 4.7893718,2.99037842 C4.49013973,2.93711651 4.2043869,3.13651473 4.151125,3.4357468 L3.74633225,5.70992326 L1.47062879,6.0007185 Z" id="Shape"
              transform="translate(3.116675, 5.039378) scale(-1, 1) rotate(19.000000) translate(-3.116675, -5.039378) "></path>
              <path d="M10.9455378,18.7110729 C15.7460934,18.7193218 19.7974328,15.185495 20.3746483,10.4803733 C20.9520269,5.77392199 17.8703406,1.38741352 13.2045462,
              0.266823691 C8.54121088,-0.853175544 3.76337955,1.64184688 2.0814696,6.07961382 C1.97375498,6.36382189 2.11683119,6.68153799 2.40103925,6.78925261 C2.68524731,
              6.89696723 3.00296342,6.75389102 3.11067804,6.46968296 C4.59532906,2.5523893 8.82066135,0.345886369 12.9475116,1.3370373 C17.0719029,2.32759764 19.7910887,
              6.19811878 19.2821912,10.3463527 C18.7731311,14.4959118 15.1941451,17.617723 10.9474323,17.610413 C10.6434975,17.6098898 10.3966855,17.8558536 10.3961623,
              18.1597884 C10.3956392,18.4637232 10.6416029,18.7105352 10.9455378,18.7110729 Z" id="Path"></path>
          </g>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-direct-deposit": {
    g: commonGAttributes.commonTwo,
    parts: [
      `<g transform="translate(-0.250000, 8.750000)" fill="currentColor" fill-rule="nonzero">
              <g transform="translate(3.750000, 0.000000)">
                  <path d="M3,0 L3,9 L0,9 L0,0 L3,0 Z M2,1 L1,1 L1,8 L2,8 L2,1 Z"></path>
                  <path d="M8,0 L8,9 L5,9 L5,0 L8,0 Z M7,1 L6,1 L6,8 L7,8 L7,1 Z"></path>
                  <path d="M13,0 L13,9 L10,9 L10,0 L13,0 Z M12,1 L11,1 L11,8 L12,8 L12,1 Z"></path>
              </g>
              <path d="M19,8 C19.5522847,8 20,8.44771525 20,9 L20,10 C20,10.5522847 19.5522847,11 19,11 L1.5,11 C0.94771525,11 0.5,10.5522847 0.5,10 L0.5,9 C0.5,
              8.44771525 0.94771525,8 1.5,8 L19,8 Z M1.5,9 L1.5,10 L19,10 L19,9 L1.5,9 Z"></path>
          </g>
          <path d="M10.959397,0.537131512 L19.4451145,7.53566141 C19.977704,7.97491048 20.0533713,8.7627413 19.6141223,9.2953308 C19.376667,9.58324531 19.0229857,
          9.75 18.6497837,9.75 L1.36021634,9.75 C0.669860405,9.75 0.110216342,9.19035594 0.110216342,8.5 C0.110216342,8.12679795 0.276971035,7.77311667 0.564885544,
          7.53566141 L9.05060304,0.537131512 C9.60478617,0.08007326 10.4052138,0.08007326 10.959397,0.537131512 Z M10.3231323,1.30860239 L10.2503325,1.25861164 C10.0729848,
          1.15863015 9.84850443,1.17529373 9.68686768,1.30860239 L1.20115018,8.30713228 C1.14356728,8.35462333 1.11021634,8.42535959 1.11021634,8.5 C1.11021634,
          8.63807119 1.22214515,8.75 1.36021634,8.75 L18.6497837,8.75 C18.7244241,8.75 18.7951603,8.71664906 18.8426514,8.65906616 C18.9305012,8.55254826 18.9153677,
          8.3949821 18.8088498,8.30713228 L10.3231323,1.30860239 Z" fill="currentColor" fill-rule="nonzero"></path>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-favorite-heart-hollow": {
    g: [],
    parts: [
      `<path d="M14.2,1.6c-1.8-0.1-3.4,0.9-4,2.6c0,0.1-0.1,0.1-0.1,0.1s-0.1,0-0.1-0.1
                        c-0.6-1.7-2.2-2.7-4-2.6c-1.4,0-2.8,0.6-3.8,1.7S0.6,5.7,0.6,7.1c0,1.4,0.5,2.8,1.4,3.8l7.5,7.3c0.2,0.2,0.6,0.2,0.9,0l7.4-7.2
                        c1-1.1,1.6-2.5,1.6-4C19.5,4.1,17.1,1.6,14.2,1.6"/>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-house-hollow": {
    g: commonGAttributes.commonTwo,
    parts: [
      `<g transform="translate(-2.500000, -1.000000)" fill="currentColor" fill-rule="nonzero">
              <path d="M13.4850847,1.40784456 L21.9821075,8.80733526 C22.5027268,9.26070795 22.557241,10.0502845 22.1038683,10.5709039 C21.8664729,10.843511 21.5226884,
              11 21.1612036,11 L19.5,11 L19.5,21 L5.5,21 L5.5,11 L3.83879641,11 C3.14844047,11 2.58879641,10.4403559 2.58879641,9.75 C2.58879641,9.38851523 2.74528537,
              9.04473065 3.01789253,8.80733526 L11.5149153,1.40784456 C12.0795887,0.916108145 12.9204113,0.916108145 13.4850847,1.40784456 Z M18.5,10 L21.1612036,10 C21.2335005,
              10 21.3022575,9.96870221 21.3497365,9.91418078 C21.4404111,9.8100569 21.4295082,9.65214159 21.3253844,9.56146705 L12.8283616,2.16197635 C12.6401371,
              1.99806421 12.3598629,1.99806421 12.1716384,2.16197635 L3.67461563,9.56146705 C3.6200942,9.60894613 3.58879641,9.67770305 3.58879641,9.75 C3.58879641,
              9.88807119 3.70072522,10 3.83879641,10 L6.5,10 L6.5,20 L18.5,20 L18.5,10 Z" id="Path-4"></path>
              <path d="M19,6.3 L19,1.55 C19,1.27385763 18.7761424,1.05 18.5,1.05 C18.2238576,1.05 18,1.27385763 18,1.55 L18,6.3 C18,6.57614237 18.2238576,6.8 18.5,6.8 C18.7761424,
              6.8 19,6.57614237 19,6.3 Z" id="Path"></path>
              <path d="M14.5,15 L14.5,21 L10.5,21 L10.5,15 L14.5,15 Z M13.5,16 L11.5,16 L11.5,20 L13.5,20 L13.5,16 Z" id="Rectangle"></path>
          </g>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-lock": {
    g: commonGAttributes.commonTwo,
    parts: [
      `<g transform="translate(1.000000, 0.000000)" fill-rule="nonzero">
              <g>
                  <g>
                      <g>
                          <path d="M16.6842105,8 C17.410901,8 18,8.58909901 18,9.31578947 L18,18.6842105 C18,19.410901 17.410901,20 16.6842105,20 L1.31578947,20 C0.589099013,
                          20 0,19.410901 0,18.6842105 L0,9.31578947 C0,8.58909901 0.589099013,8 1.31578947,8 L16.6842105,8 Z M16.6842105,9 L1.31578947,9 C1.14138376,9 1,
                          9.14138376 1,9.31578947 L1,18.6842105 C1,18.8586162 1.14138376,19 1.31578947,19 L16.6842105,19 C16.8586162,19 17,18.8586162 17,18.6842105 L17,
                          9.31578947 C17,9.14138376 16.8586162,9 16.6842105,9 Z" fill="currentColor"></path>
                          <path d="M8.375,0 L9.625,0 C11.9722102,0 13.8876977,1.90123652 13.9952381,4.2881643 L14,4.5 L14,9 L4,9 L4,4.5 C4,2.08572667 5.8484244,
                          0.115510912 8.16904862,0.00489798951 L8.375,0 L9.625,0 L8.375,0 Z M13,8 L13,4.5 C13,2.56079715 11.4825583,1 9.625,1 L8.375,1 C6.51744166,1 5,
                          2.56079714 5,4.5 L5,8 L13,8 Z" fill="currentColor"></path>
                          <circle id="Oval" stroke="currentColor" stroke-width="2" cx="9" cy="13" r="1"></circle>
                      </g>
                  </g>
                  <polygon fill="currentColor" points="8.5 17.7631579 9.5 17.7631579 9.5 11.5 8.5 11.5"></polygon>
              </g>
          </g>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-suitcase": {
    g: commonGAttributes.commonTwo,
    parts: [
      `<g transform="translate(0.000000, 2.000000)">
              <path d="M19,4 L19,14 L1,14 L1,4 L19,4 L19,4 Z M18.8235294,3 L1.17647059,3 C0.526723824,3 0,3.50924957 0,4.13744076 L0,13.8625592 C0,14.4907504 0.526723824,
              15 1.17647059,15 L18.8235294,15 C19.4732762,15 20,14.4907504 20,13.8625592 L20,4.13744076 C20,3.50924957 19.4732762,3 18.8235294,3 Z" id="Shape" fill="#272525"
              fill-rule="nonzero"></path>
              <path d="M13,3 L13,0.752808989 C13,0.553151631 12.9152931,0.361671719 12.7645139,0.220492648 C12.6137346,0.0793135765 12.4092341,0 12.196,0 L7.804,0 C7.35996306,
              0 7,0.337044065 7,0.752808989 L7,3" id="Path" stroke="#272525"></path>
          </g>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-copy": {
    g: commonGAttributes.commonTwo,
    parts: [
      `<g id="copy" transform="translate(-1182.000000, -369.000000)" fill-rule="nonzero" stroke="currentColor">
              <g id="-icon💎/Copy/small/CopySM-white" transform="translate(1179.000000, 368.000000)">
                  <path d="M12.387544,1.5 L3.5,14.2239985 L3.5,15.625 C3.5,16.1082492 3.89175084,16.5 4.375,16.5 L13.6,16.5 C14.0970563,16.5 14.5,16.0970563 14.5,15.6 L14.5,
                  2.31715573 C14.5,1.86585308 14.1341469,1.5 13.6828443,1.5 L12.387544,1.5 Z" id="Rectangle" transform="translate(9.000000, 9.000000) scale(-1, -1)
                  translate(-9.000000, -9.000000) "></path>
                  <rect id="Rectangle" transform="translate(11.000000, 11.000000) scale(-1, -1) translate(-11.000000, -11.000000) " x="5.5" y="3.5" width="11" height="15" rx="0.5">
                  </rect>
              </g>
          </g>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-phone": {
    g: [],
    parts: [
      `<path id="Shape" d="M15,1v18H5V1H15L15,1z M15,0H5C4.4,0,4,0.4,4,1v18c0,0.6,0.4,1,1,1h10c0.6,0,1-0.4,1-1V1C16,0.4,15.6,0,15,0z" />
          <circle id="Oval" class="st0" cx="10" cy="17" r="1"/>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-success": {
    g: commonGAttributes.commonTwo,
    parts: [
      `<g transform="translate(1.000000, 1.000000)" fill="currentColor" fill-rule="nonzero">
            <path d="M9,17.4 C4.3608081,17.4 0.6,13.6391919 0.6,9 C0.6,4.3608081 4.3608081,0.6 9,0.6 C13.6391919,0.6 17.4,4.3608081 17.4,9 C17.4,13.6391919 13.6391919,17.4 9,
            17.4 Z M9,16.2 C12.9764502,16.2 16.2,12.9764502 16.2,9 C16.2,5.0235498 12.9764502,1.8 9,1.8 C5.0235498,1.8 1.8,5.0235498 1.8,9 C1.8,12.9764502 5.0235498,16.2 9,16.2
            Z" id="Oval"></path>
            <path d="M7.26666667,10.9418355 L12.4780864,5.78768416 C12.7136919,5.55466769 13.0935851,5.55676655 13.3266016,5.79237209 C13.559618,6.02797762 13.5575192,
            6.40787081 13.3219136,6.64088727 L7.6885803,12.2123158 C7.45481351,12.4435138 7.07851983,12.4435138 6.84475304,12.2123158 L4.12094351,9.51843829 C3.88533798,
            9.28542183 3.88323912,8.90552864 4.11625558,8.66992311 C4.34927205,8.43431757 4.72916524,8.43221871 4.96477077,8.66523518 L7.26666667,10.9418355 Z" id="Shape"></path>
        </g>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-success-filled": {
    g: commonGAttributes.commonTwo,
    parts: [
      `<g transform="translate(1.000000, 1.000000)">
              <g id="Icon-small-checkCircle" transform="translate(0.593407, 0.593407)">
                  <circle fill="currentColor" fill-rule="nonzero" cx="8.30769231" cy="8.30769231" r="8.30769231"></circle>
                  <path d="M6.58461538,10.2423177 L11.7673382,5.11654791 C12.0003546,4.88609207 12.3760732,4.88816786 12.606529,5.12118432 C12.8369849,5.35420079 12.8349091,
                  5.72991932 12.6018926,5.96037517 L7.0018926,11.4988367 C6.77069468,11.727494 6.39853609,11.727494 6.16733817,11.4988367 L3.45964586,8.82089926 C3.2266294,
                  8.59044342 3.22455361,8.21472488 3.45500945,7.98170841 C3.68546529,7.74869195 4.06118383,7.74661616 4.29420029,7.977072 L6.58461538,10.2423177 Z" fill="#FFFFFF"
                  fill-rule="nonzero"></path>
              </g>
          </g>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-warning": {
    g: commonGAttributes.commonTwo,
    parts: [
      `<g transform="translate(1.000000, 1.000000)">
              <g id="Warning1" stroke-width="1" fill-rule="evenodd" transform="translate(0.000000, 1.200000)" stroke="currentColor">
                  <path d="M17.3370386,15.0152343 L9.00860887,0.707983877 L0.679983758,15.0151479 L17.3370386,15.0152343 Z" stroke-width="1.2"></path>
              </g>
              <path d="M8.19,14.04 C8.16437588,13.8281014 8.2368299,13.6160897 8.38677958,13.4641927 C8.53672927,13.3122956 8.74778837,13.2371121 8.96,13.26 C9.16715704,
              13.2467652 9.37034806,13.3211477 9.52,13.465 C9.65709398,13.6241339 9.72701115,13.8303 9.715,14.04 C9.72048715,14.2522748 9.64341383,14.4584012 9.5,14.615
              C9.35312473, 14.7641498 9.1489517,14.8425377 8.94,14.83 C8.72997224,14.8424095 8.52401376,14.7683367 8.37,14.625 C8.23531653,14.4613056 8.17063593,14.2510936
              8.19,14.04 Z M9.415, 12.395 L8.5,12.395 L8.25,7.16 L9.675,7.16 L9.415,12.395 Z" fill="currentColor" fill-rule="nonzero"></path>
          </g>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-warning-filled": {
    g: commonGAttributes.commonTwo,
    parts: [
      `<g transform="translate(1.000000, 1.000000)">
            <g id="Warning2" transform="translate(0.000000, 1.200000)">
                <path d="M17.9465423,14.8670135 L9.44311247,0.246687943 C9.35049358,0.100809118 9.18936767,0.012383152 9.01617259,0.012383152 C8.84297751,0.012383152 8.68185161,
                0.100809118 8.58923271,0.246687943 L0.0706452929,14.8670135 C-0.0142965839,15.0216954 -0.0118890438,15.2093943 0.0769925071,15.3618609 C0.165874058,
                15.5143276 0.328282319,15.6093523 0.505163987,15.6123832 L17.5120236,15.6123832 C17.6889052,15.6093523 17.8513135,15.5143276 17.940195,15.3618609 C18.0290766,
                15.2093943 18.0314841,15.0216954 17.9465423,14.8670135 Z" fill="currentColor" fill-rule="nonzero"></path>
                <path d="M8.19,12.84 C8.16437588,12.6281014 8.2368299,12.4160897 8.38677958,12.2641927 C8.53672927,12.1122956 8.74778837,12.0371121 8.96,12.06 C9.16715704,
                12.0467652 9.37034806,12.1211477 9.52,12.265 C9.65709398,12.4241339 9.72701115,12.6303 9.715,12.84 C9.72048715,13.0522748 9.64341383,13.2584012 9.5,13.415
                C9.35312473, 13.5641498 9.1489517,13.6425377 8.94,13.63 C8.72997224,13.6424095 8.52401376,13.5683367 8.37,13.425 C8.23531653,13.2613056 8.17063593,13.0510936
                8.19,12.84 Z M9.415, 11.195 L8.5,11.195 L8.25,5.96 L9.675,5.96 L9.415,11.195 Z" fill="#FFFFFF" fill-rule="nonzero"></path>
            </g>
        </g>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-cloud": {
    g: [
      { stroke: "currentColor" },
      { fill: "none" },
      { transform: "translate(0.000000, 2.000000)" }
    ],
    parts: [
      `<path d="M15.81,13.17 L4.5,13.17 C2.68,13.17 0.57,11.55 0.57,9.56 C0.543873106,8.11261637 1.37559165,6.78657454 2.69,6.18 C2.81646732,6.1095036 2.89347113,
          5.97474694 2.89,5.83 C2.87663824,4.95475631 3.21156498,4.11006267 3.82107965,3.4817937 C4.43059433,2.85352472 5.26475327,2.49316083 6.14,2.48 C6.89450101,
          2.48415894 7.62358268,2.75314053 8.2,3.24 C8.27148006,3.30171834 8.36719521,3.3274878 8.46,3.31 C8.55292702,3.29077872 8.63308224,3.23248401 8.68,3.15 C9.44839271,
          1.72687525 10.9326993,0.837058381 12.55,0.83 C13.7505868,0.848404753 14.8945127,1.34375559 15.7293683,2.20675239 C16.5642239,3.0697492 17.0213929,4.22946275 17,
          5.43 C17,5.55 17,5.67 17,5.79 C16.9856192,5.93765246 17.0715342,6.0767528 17.21,6.13 C18.5959137,6.69794473 19.4871762,8.06269042 19.45,9.56 C19.3770532,
          11.5343108 17.7848469,13.1133945 15.81,13.17 Z" id="Shape"></path>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-direction-mc": {
    g: [{ stroke: "none" }, { fill: "none" }, { "fill-rule": "evenodd" }],
    parts: [
      `<g id="Triangle/Down-Copy" transform="translate(10.000000, 9.500000) scale(1, -1) translate(-10.000000, -9.500000) translate(5.000000, 7.000000)" fill="currentColor">
              <path d="M5.08838835,0.0366116524 L10,4.9482233 L0,4.9482233 L4.91161165,0.0366116524 C4.96042719,-0.0122038841 5.03957281,-0.0122038841 5.08838835,0.0366116524 Z"
              id="Triangle" transform="translate(5.000000, 2.474112) scale(1, -1) translate(-5.000000, -2.474112) "></path>
          </g>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-dollar": {
    g: commonGAttributes.commonTwo,
    parts: [
      `<g id="Icon-small-paymentdollar" transform="translate(5.000000, 2.000000)" fill="currentColor">
            <path d="M5.64,13.94 L5.64,15.71 L4.77,15.71 L4.77,13.92 C3.17323088,13.7820908 1.67090369,13.1049856 0.51,12 L1.1,11.3 C2.08517494,12.3194632 3.3995149,12.9571483
            4.81, 13.1 L4.81,8 C2.11,7.39 1,6.4 1,4.6 C1,2.8 2.58,1.39 4.77,1.34 L4.77,0.34 L5.64,0.34 L5.64,1.37 C6.92675616,1.47317575 8.14487873,1.99272082 9.11,2.85 L8.52,
            3.55 C7.71338991,2.79994261 6.69240461,2.32091869 5.6,2.18 L5.6,7.24 C8.34,7.82 9.49,8.85 9.49,10.61 C9.49,12.52 7.91,13.85 5.64,13.94 Z M4.81,2.15 C3.06,
            2.15 1.91,3.23 1.91,4.52 C1.91,5.81 2.47,6.52 4.81,7.06 L4.81,2.15 Z M5.6,8.15 L5.6,13.15 C7.4,13.1 8.6,12.07 8.6,10.7 C8.6,9.33 8,8.7 5.6,8.16 L5.6,8.15 Z"
            id="Shape"></path>
        </g>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-download": {
    g: commonGAttributes.commonFour,
    parts: [
      `<g id="Icon-small-cloudDownload" transform="translate(0.000000, 2.000000)" stroke="currentColor">
            <path d="M10.38,17.67 L10.38,9.87" id="Shape"></path>
            <polyline stroke-linejoin="round" points="12.98 15.07 10.38 17.68 7.78 15.07"></polyline>
            <path d="M8.12,12.34 L4.5,12.34 C2.68,12.34 0.58,10.72 0.58,8.72 C0.55088889,7.27710409 1.37929052,5.95401714 2.69,5.35 C2.81646732,5.2795036 2.89347113,
            5.14474694 2.89,5 C2.86214337,3.17569454 4.31577781,1.67286017 6.14,1.64 C6.89559551,1.64780386 7.62454058,1.92027361 8.2,2.41 C8.27148006,2.47171834 8.36719521,
            2.4974878 8.46,2.48 C8.55540562,2.45981513 8.63640055,2.39722814 8.68,2.31 C9.45425643,0.893835515 10.9360275,0.00936749265 12.55,0 C15.0440886,0.0438285706
            17.0334245, 2.09575031 17,4.59 C17,4.72 17,4.84 17,4.96 C16.9856192,5.10765246 17.0715342,5.2467528 17.21,5.3 C18.5904099,5.8675146 19.4774804,7.22795461 19.44,
            8.72 C19.3779444, 10.6891426 17.7989634,12.2724975 15.83,12.34 L12.55,12.34" id="Shape"></path>
        </g>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-edit": {
    g: commonGAttributes.commonFour,
    parts: [
      `<g id="Icon-small-write" stroke="currentColor">
              <path d="M0.67,19.5 L3.51,19.5 L19.08,3.94 C19.4605106,3.56176454 19.673099,3.04650794 19.67,2.51 C19.67,1.4054305 18.7745695,0.51 17.67,0.51 C17.1369554,
              0.509577624 16.6257964,0.721960602 16.25,1.1 L0.67,16.65 L0.67,19.5 Z" id="Shape"></path>
              <path d="M14.22,3.1 L17.06,5.95" id="Shape"></path>
          </g>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-edit-mc": {
    g: commonGAttributes.commonFour,
    parts: [
      `<g id="Icon-small-write" transform="translate(2.000000, 2.000000)" stroke="currentColor">
              <path d="M0.5,15.5 L2.74210132,15.5 L15.034185,3.2093211 C15.3345875,2.91055693 15.5024202,2.5035612 15.4999736,2.07977928 C15.4999736,1.20729155 14.793056,
              0.500000497 13.921029,0.500000497 C13.5002051,0.499666866 13.0966592,0.667425927 12.7999784,0.966035236 L0.5,13.2488152 L0.5,15.5 Z" id="Shape"></path>
              <path d="M11.5,2.5 L13.5,4.5" id="Shape"></path>
          </g>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-email": {
    g: commonGAttributes.commonTwo,
    parts: [
      `<path d="M1.5,16.6425781 L18.5,16.6425781 C19.0522847,16.6425781 19.5,16.1948629 19.5,15.6425781 L19.5,5 C19.5,4.44771525 19.0522847,4 18.5,4 L1.5,4 C0.94771525,
          4 0.5,4.44771525 0.5,5 L0.5,15.6425781 C0.5,16.1948629 0.94771525,16.6425781 1.5,16.6425781 Z" id="Stroke-1" stroke="currentColor"></path>
          <path d="M19.5,4.5 L11.1480604,10.3544583 C10.4589576,10.8374986 9.54119893,10.8375022 8.85209229,10.3544673 L0.5,4.5" id="Stroke-3" stroke="currentColor"></path>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-expand-more": {
    g: commonGAttributes.commonOne,
    parts: [
      `<polyline stroke="currentColor" transform="translate(10.000000, 11.000000) rotate(180.000000) translate(-10.000000, -11.000000) " points="6 13 10 9 14 13"></polyline>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-expand-less": {
    g: commonGAttributes.commonOne,
    parts: [
      `<polyline stroke="currentColor" points="6 12 10 8 14 12"></polyline>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-export": {
    g: commonGAttributes.commonFour,
    parts: [
      `<g id="Icon-small-share" stroke="currentColor">
              <path d="M10.82,0.5 L2.42,0.5 C1.90274419,0.510378298 1.4113116,0.727993211 1.05596971,1.10401638 C0.70062782,1.48003954 0.511131545,1.98298427 0.53,2.5 L0.53,
              17.58 C0.508351307,18.0977629 0.696916313,18.602291 1.05284569,18.9789358 C1.40877507,19.3555807 1.90184112,19.5723553 2.42,19.58 L17.58,19.58 C18.0972558,
              19.5696217 18.5886884,19.3520068 18.9440303,18.9759836 C19.2993722,18.5999605 19.4888685,18.0970157 19.47,17.58 L19.47,13.84" id="Shape"></path>
              <polyline stroke-linejoin="round" points="15.82 2.48 19.34 5.99 15.82 10.21"></polyline>
              <path d="M16.11,6 C16.11,6 3.34,4.36 3.94,16.56" id="Shape"></path>
          </g>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-eye": {
    g: [],
    parts: [
      `<path d="M10,4.3c4.4,0,7.8,4.2,8.8,5.7c-1,1.5-4.4,5.7-8.8,5.7c-4.4,0-7.8-4.2-8.8-5.7C2.2,8.5,5.6,4.3,10,4.3 M10,3.3
          C4,3.3,0,10,0,10s4,6.7,10,6.7S20,10,20,10S16,3.3,10,3.3L10,3.3z"/>
            <path d="M12.4,9.1c-0.9,0-1.6-0.7-1.6-1.6c0-0.4,0.2-0.80.4-1c-0.4-0.1-0.8-0.2-1.2-0.2c-2.1,0-3.8,1.7-3.8,3.8
            c0,2.1,1.7,3.8,3.8,3.8s3.8-1.7,3.8-3.8c0-0.5-0.1-1-0.3-1.4C13.2,8.9,12.8,9.1,12.4,9.1z"/>`
    ],
    viewBox: "0 0 20 20"
  },
  "icon-globe": {
    g: commonGAttributes.commonTwo,
    parts: [
      `<g id="Page-1" transform="translate(1.500000, 1.500000)">
              <path d="M9.38229308,16.0162811 C10.2138399,15.2493725 10.9139077,14.3775185 11.4640434,13.4272437 L14.2389417,13.4272437 C13.0302578,14.8330507 11.3175712,
              15.7913981 9.38229308,16.0162811 Z M2.76336499,13.4272437 L5.53826323,13.4272437 C6.08839891,14.3775185 6.78846676,15.2493725 7.62001357,16.0162811 C5.68358209,
              15.7913981 3.97204885,14.8330507 2.76336499,13.4272437 Z M7.48046133,1.00332406 C6.52089552,1.79445085 5.74816825,2.75510481 5.18303935,3.83454311 L2.54769335,
              3.83454311 C3.73561737,2.3214843 5.48405699,1.27549013 7.48046133,1.00332406 Z M14.45346,3.83454311 L11.818114,3.83454311 C11.2541384,2.75510481 10.4825645,
              1.79445085 9.52184532,1.00332406 C11.5182497,1.27549013 13.265536,2.3214843 14.45346,3.83454311 Z M12.8791723,8.16613527 C12.878019,8.04619768 12.8918589,
              7.92626009 12.8860923,7.8063225 C12.8399593,6.73726341 12.6139077,5.71433417 12.2425373,4.76059969 L14.9182497,4.76059969 C14.9701493,4.76059969 15.0162822,
              4.74791398 15.0624152,4.73407503 C15.6506106,5.75354454 16.0023745,6.92062954 16.0565807,8.16613527 L12.8791723,8.16613527 Z M12.8561058,9.09334509 L16.0438942,
              9.09334509 C15.9458616,10.3376976 15.5468114,11.4967099 14.919403,12.5000339 L11.9507463,12.5000339 C12.4420624,11.4194424 12.75346,10.2696561 12.8561058,
              9.09334509 Z M11.2379919,4.76059969 C11.6589552,5.71433417 11.9126866,6.75456211 11.9599729,7.84668611 C11.9645862,7.953938 11.9530529,8.06003663 11.9530529,
              8.16613527 L5.04810041,8.16613527 C5.04925373,8.06003663 5.03772049,7.953938 5.04233379,7.84668611 C5.08962008,6.75456211 5.34335142,5.71433417 5.76431479,
              4.76059969 L11.2379919,4.76059969 Z M8.5,1.39196798 C9.42381275,2.05969744 10.1838535,2.88772811 10.7535957,3.83454311 L6.24755767,3.83454311 C6.81729986,
              2.88772811 7.57734057,2.05969744 8.5,1.39196798 Z M1.92374491,4.7582932 C1.92835821,4.7582932 1.93181818,4.76059969 1.93527815,4.76059969 L4.75976934,
              4.76059969 C4.38839891,5.71433417 4.16234735,6.73726341 4.11621438,7.8063225 C4.11160109,7.92626009 4.12313433,8.04619768 4.12313433,8.16613527 L0.944572592,
              8.16613527 C0.997625509,6.93100875 1.34477612,5.77199647 1.92374491,4.7582932 Z M0.957259159,9.09334509 L4.14735414,9.09334509 C4.24884668,10.2696561 4.55909091,
              11.4194424 5.0527137,12.5000339 L2.08290366,12.5000339 C1.45434193,11.4967099 1.05529172,10.3376976 0.957259159,9.09334509 Z M6.08955224,12.5000339 C5.54287653,
              11.4286683 5.19457259,10.2765755 5.08154681,9.09334509 L11.9207598,9.09334509 C11.8088874,10.2765755 11.4594301,11.4286683 10.9127544,12.5000339 L6.08955224,
              12.5000339 Z M8.5,15.5642087 C7.7687924,14.9322298 7.13792402,14.2137575 6.62354138,13.4272437 L10.3776119,13.4272437 C9.86553596,14.2137575 9.23351425,14.9322298
              8.5, 15.5642087 Z M8.5,0 C3.81404342,0 0,3.81263144 0,8.49827013 C0,13.1862153 3.81404342,17 8.5,17 C13.1882632,17 17,13.1862153 17,8.49827013 C17,3.81263144
              13.1882632, 0 8.5,0 Z" id="Fill-1" fill="currentColor"></path>
          </g>`
    ],
    viewBox: "0 0 20 20"
  }
};

export default partOne;
